(() => {
  // Shopify can request this asset again while replacing a section in the editor.
  if (window.AstrellaExperience) { window.AstrellaExperience.refresh(); return; }
  const instances = new Map(), modalLocks = new Set();
  let previousOverflow = '', previousOverflowPriority = '';
  const lockScroll = dialog => {
    if (!modalLocks.size) {
      previousOverflow = document.documentElement.style.getPropertyValue('overflow');
      previousOverflowPriority = document.documentElement.style.getPropertyPriority('overflow');
      document.documentElement.style.setProperty('overflow', 'hidden');
    }
    modalLocks.add(dialog);
  };
  const unlockScroll = dialog => {
    if (!modalLocks.delete(dialog) || modalLocks.size) return;
    if (previousOverflow) document.documentElement.style.setProperty('overflow', previousOverflow, previousOverflowPriority);
    else document.documentElement.style.removeProperty('overflow');
  };
  const initialize = () => document.querySelectorAll('[data-experience]:not([data-ready])').forEach(root => {
    root.dataset.ready = 'true';
    const controller = new AbortController(), signal = controller.signal;
    const on = (el, event, fn, options = {}) => el?.addEventListener(event, fn, {...options, signal});
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    let paused = reduced.matches, frame = 0, visible = true, phase = 0, lastTime = null;
    // Motion follows the device preference. The removed control's old session value
    // must not leave returning visitors with a permanently frozen scene.
    const timers = new Set();
    const later = (callback, delay) => { const id = setTimeout(() => { timers.delete(id); if (!signal.aborted) callback(); }, delay); timers.add(id); };
    const canvas = root.querySelector('canvas.fx-canvas');
    let ctx = null;
    try { ctx = canvas?.getContext('2d', {alpha:false}); } catch { /* The CSS hero stays visible if canvas is unavailable. */ }
    const orb=ctx?window.AstrellaOrb?.create({size:768}):null;
    const productOrbit = root.querySelector('.fx-product-orbit');
    let orbitTime = 0, orbitSpeed = 1, orbitHover = false, orbitFocus = false;
    const orbitProducts = [...(productOrbit?.querySelectorAll('[data-orbit-photo]') || [])].map(link => {
      const entry = {link, sprite:null};
      if (!ctx) return entry;
      const image = new Image();
      image.decoding = 'async';
      image.onload = () => {
        if (signal.aborted) return;
        // Crop only in the scene: the full product photography remains unchanged.
        // Every colour shares the same silhouette and physical scale.
        const sprite = document.createElement('canvas');
        sprite.width = 126; sprite.height = 585;
        const paint = sprite.getContext('2d');
        if (!paint) return;
        paint.scale(.6,.6); paint.translate(-570,-155);
        paint.translate(670,635); paint.rotate(-25.5*Math.PI/180); paint.translate(-670,-635);
        paint.clip(new Path2D('M823 211 Q866 193 910 209 Q927 212 923 226 L798 527 L526 1061 Q521 1075 502 1067 Q454 1054 427 1035 Q422 1030 427 1015 L663 510 L811 229 Q817 216 823 211Z'));
        paint.drawImage(image,0,0,1254,1254); entry.sprite=sprite;
        productOrbit.classList.add('is-rendered'); link.classList.add('is-painted'); draw();
      };
      image.src = link.dataset.orbitPhoto;
      on(link,'pointerenter',event=>{if(event.pointerType!=='touch')orbitHover=true;});
      on(link,'pointerleave',()=>{orbitHover=false;});
      on(link,'focus',()=>{orbitFocus=true;});
      on(link,'blur',()=>{orbitFocus=false;});
      return entry;
    });
    const collectionScenes=[...root.querySelectorAll('.fx-coming-art')].map(element=>window.AstrellaCollection?.create({element,signal,reduced,finePointer})).filter(Boolean);
    let w=1,h=1,px=0,py=0,targetX=0,targetY=0,filteredX=0,filteredY=0,velocityX=0,velocityY=0,background=null,glow=null,nebula=null,satelliteTexture=null,ribbonSamples=[];
    const stars=Array.from({length:128},(_,i)=>({x:((i*719)%997)/997,y:((i*337)%991)/991,r:i%13===0?1.2:i%4===0?.7:.38,a:.07+(i%8)*.026,depth:.35+(i%7)*.09}));
    const dust=Array.from({length:76},(_,i)=>({x:((i*431+83)%997)/997,y:((i*683+29)%991)/991,r:.25+(i%5)*.16,a:.025+(i%6)*.012}));
    const resize = () => {
      if(!canvas||!ctx)return;const r=canvas.getBoundingClientRect();w=r.width;h=r.height;if(!w||!h)return;
      const d=Math.min(devicePixelRatio||1,1.5);canvas.width=Math.round(w*d);canvas.height=Math.round(h*d);ctx.setTransform(d,0,0,d,0,0);
      ctx.imageSmoothingQuality='high';
      background=ctx.createLinearGradient(0,0,w,h);background.addColorStop(0,'#14130f');background.addColorStop(.55,'#201c16');background.addColorStop(1,'#282117');
      glow=ctx.createRadialGradient(w*.74,h*.45,0,w*.74,h*.45,w*.54);glow.addColorStop(0,'#c5a47532');glow.addColorStop(.45,'#aa805518');glow.addColorStop(1,'#18161100');
      nebula=ctx.createRadialGradient(w*.93,h*.78,0,w*.93,h*.78,w*.52);nebula.addColorStop(0,'#ad824b18');nebula.addColorStop(.5,'#77563212');nebula.addColorStop(1,'#33241000');
      const steps=w<750?84:110;
      ribbonSamples=Array.from({length:steps+1},(_,i)=>{const a=i/steps*Math.PI*2;return {c:Math.cos(a),s:Math.sin(a),c2:Math.cos(a*2),s2:Math.sin(a*2),c3:Math.cos(a*3),s3:Math.sin(a*3)};});
      // Small companion and its light are cached alongside the main sphere.
      satelliteTexture=document.createElement('canvas');satelliteTexture.width=satelliteTexture.height=96;
      const satellite=satelliteTexture.getContext('2d');
      if(satellite){
        const light=satellite.createRadialGradient(48,48,6,48,48,46);
        light.addColorStop(0,'#ebce9270');light.addColorStop(.35,'#c7985030');light.addColorStop(1,'#c7985000');
        satellite.fillStyle=light;satellite.fillRect(0,0,96,96);
        const stone=satellite.createRadialGradient(42,41,0,49,50,14);
        stone.addColorStop(0,'#f5e5c6');stone.addColorStop(.35,'#c8a46e');stone.addColorStop(.75,'#6c5130');stone.addColorStop(1,'#211a12');
        satellite.fillStyle=stone;satellite.beginPath();satellite.arc(48,48,12,0,Math.PI*2);satellite.fill();
      }
      draw();
    };
    function draw(){
      if(!ctx||!w||!h)return;
      ctx.fillStyle=background||'#15140f';ctx.fillRect(0,0,w,h);ctx.fillStyle=glow||'transparent';ctx.fillRect(0,0,w,h);
      ctx.fillStyle=nebula||'transparent';ctx.fillRect(0,0,w,h);
      for(const star of stars){const twinkle=star.a*(.78+.22*Math.sin(phase*.65+star.x*14));ctx.fillStyle=`rgba(228,209,177,${twinkle})`;ctx.beginPath();ctx.arc(star.x*w+px*14*star.depth+Math.sin(phase*.12+star.y*5)*3*star.depth,star.y*h+py*12*star.depth,star.r,0,Math.PI*2);ctx.fill();}
      for(const mote of dust){ctx.fillStyle=`rgba(232,216,190,${mote.a})`;ctx.beginPath();ctx.arc(mote.x*w+px*20+Math.sin(phase*.19+mote.x*9)*9,mote.y*h+py*18+Math.cos(phase*.16+mote.y*8)*7,mote.r,0,Math.PI*2);ctx.fill();}
      const mobile=w<750;
      const hasProducts=orbitProducts.length>0;
      const radius=hasProducts?Math.min(w*(mobile?.30:.205),mobile?150:300,mobile?Infinity:(w*.28-42)/1.43,h*.31):Math.min(w*(mobile?.43:.245),mobile?225:Infinity,h*.35),rings=mobile?20:34;
      const cx=w*(mobile?(hasProducts?.5:.72):(hasProducts?.72:.755))+px*14+Math.sin(phase*.22)*3,cy=(mobile?(hasProducts?92+radius*1.35:100+radius*.84):h*.46)+py*12+Math.sin(phase*.31)*4;
      const productTilt=-.30;
      const productPositions=orbitProducts.map((entry,index)=>{
        const a=orbitTime*.12+index*Math.PI*2/orbitProducts.length+.25;
        const depth=Math.sin(a),xx=Math.cos(a)*radius*1.32,yy=depth*radius*.81;
        const x=cx+xx*Math.cos(productTilt)-yy*Math.sin(productTilt),y=cy+xx*Math.sin(productTilt)+yy*Math.cos(productTilt);
        const height=radius*(mobile?.76:.64)*(.91+depth*.09);
        const lean=(Math.sin(a)*9-8)*Math.PI/180;
        const occluded=depth<0&&Math.hypot(x-cx,y-cy)<radius*.74;
        entry.link.style.left=`${x}px`;entry.link.style.top=`${y}px`;entry.link.style.height=`${height+10}px`;
        entry.link.style.transform=`translate(-50%,-50%) rotate(${lean}rad)`;
        entry.link.style.pointerEvents=occluded?'none':'auto';
        entry.link.style.zIndex=depth<0?'1':'3';
        return {...entry,x,y,height,lean,depth};
      });
      const paintProduct=entry=>{
        if(!entry.sprite)return;
        ctx.save();ctx.translate(entry.x,entry.y);ctx.rotate(entry.lean);
        ctx.globalAlpha=entry.depth<0?.62:1;
        const width=entry.height*126/585;
        ctx.drawImage(entry.sprite,-width/2,-entry.height/2,width,entry.height);ctx.restore();
      };
      productPositions.filter(entry=>entry.depth<0).sort((a,b)=>a.depth-b.depth).forEach(paintProduct);
      const angle=.7+Math.sin(phase*.23)*.15+py*.10,spin=-.5+Math.sin(phase*.17)*.1+px*.12;
      const ca=Math.cos(angle),sa=Math.sin(angle),cs=Math.cos(spin),ss=Math.sin(spin);
      const p12s=Math.sin(phase*.12),p12c=Math.cos(phase*.12),p32s=Math.sin(phase*.32),p32c=Math.cos(phase*.32);
      ctx.save();ctx.translate(cx,cy);const scale=radius*.84/192;ctx.scale(scale,scale);
      if(orb)ctx.drawImage(orb.render(phase,px,py),-320,-320,640,640);
      else {ctx.fillStyle='#392b1e';ctx.beginPath();ctx.arc(0,0,192,0,Math.PI*2);ctx.fill();}
      ctx.restore();
      // A projected ribbon field: two paths per band, no per-frame gradients or assets.
      for(let band=0;band<rings;band++){
        const u=band/(rings-1),tube=(u-.5)*radius*.28;
        ctx.beginPath();
        for(let i=0;i<ribbonSamples.length;i++){
          const sample=ribbonSamples[i],warp=(sample.s3*p32c+sample.c3*p32s)*radius*.055;
          const rr=radius*1.18+tube*(sample.c2*p12c-sample.s2*p12s)+warp;
          const x=sample.c*rr,y=sample.s*rr,z=tube*(sample.s2*p12c+sample.c2*p12s);
          const ry=y*ca-z*sa,rz=y*sa+z*ca,pers=1/(1+rz/(radius*4.5));
          const sx=cx+(x*cs-ry*ss)*pers,sy=cy+(x*ss+ry*cs)*pers;
          if(i===0)ctx.moveTo(sx,sy);else ctx.lineTo(sx,sy);
        }
        const shimmer=Math.sin(u*Math.PI),r=185+u*49,g=163+u*53,b=124+u*59;
        ctx.strokeStyle=`rgba(${r},${g},${b},${.13+shimmer*.23})`;ctx.lineWidth=mobile?.85:1;ctx.stroke();
      }
      // Delicate outer trajectories keep the artwork legible behind the typography.
      ctx.strokeStyle='#d5bd9518';ctx.lineWidth=.7;ctx.beginPath();ctx.ellipse(cx,cy,radius*1.42,radius*.55,spin-.12,0,Math.PI*2);ctx.stroke();
      ctx.strokeStyle='#e5d4b51a';ctx.lineWidth=.6;ctx.beginPath();ctx.arc(cx,cy,radius*1.62,spin-.85,spin+.68);ctx.stroke();
      ctx.strokeStyle='#e5d4b512';ctx.beginPath();ctx.arc(cx,cy,radius*1.76,spin+1.1,spin+2.25);ctx.stroke();
      if(hasProducts){
        ctx.strokeStyle='#d8c3a32b';ctx.lineWidth=.7;ctx.beginPath();ctx.ellipse(cx,cy,radius*1.32,radius*.81,productTilt,0,Math.PI*2);ctx.stroke();
        productPositions.filter(entry=>entry.depth>=0).sort((a,b)=>a.depth-b.depth).forEach(paintProduct);
      }
      // A luminous companion traces the outer orbit. Its movement gives the
      // composition a clear rhythm even with no pointer input, including touch.
      const orbit=phase*.21+2.55,tilt=spin-.12,orbitX=radius*1.42,orbitY=radius*.55;
      const orbitPoint=a=>({x:cx+Math.cos(a)*orbitX*Math.cos(tilt)-Math.sin(a)*orbitY*Math.sin(tilt),y:cy+Math.cos(a)*orbitX*Math.sin(tilt)+Math.sin(a)*orbitY*Math.cos(tilt)});
      for(let segment=0;segment<18;segment++){
        const from=orbitPoint(orbit-.28+segment*.016),to=orbitPoint(orbit-.28+(segment+1)*.016);
        ctx.strokeStyle=`rgba(226,199,150,${.03+segment*.014})`;ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(from.x,from.y);ctx.lineTo(to.x,to.y);ctx.stroke();
      }
      const companion=orbitPoint(orbit),size=mobile?38:66;
      if(satelliteTexture)ctx.drawImage(satelliteTexture,companion.x-size/2,companion.y-size/2,size,size);
      const distant=phase*-.11+.68;
      ctx.fillStyle='#e9d7b890';ctx.beginPath();ctx.arc(cx+Math.cos(distant)*radius*1.62,cy+Math.sin(distant)*radius*1.62,1.8,0,Math.PI*2);ctx.fill();
    }
    function tick(time){
      frame=0;if(paused||!visible||document.hidden||!root.isConnected||!ctx)return;
      // Seed with a full frame interval; desktop motion follows display frames,
      // while touch devices retain the lower ambient rendering budget.
      const interval=1000/(finePointer.matches?60:30);
      if(lastTime===null)lastTime=time-interval;
      const elapsed=time-lastTime;
      if(elapsed>=interval-.75){
        const delta=Math.min(elapsed,50),dt=delta/1000;lastTime=time;phase+=dt;
        const orbitTarget=(orbitHover||orbitFocus)?0:1;
        orbitSpeed+=(orbitTarget-orbitSpeed)*(1-Math.exp(-dt*9));
        if(!orbitFocus)orbitTime+=dt*orbitSpeed;
        // Filter hand jitter, then critically damp the scene. Position and
        // velocity stay continuous even when the pointer reverses abruptly.
        const filter=1-Math.exp(-dt/.18);filteredX+=(targetX-filteredX)*filter;filteredY+=(targetY-filteredY)*filter;
        const spring=4.2,decay=Math.exp(-spring*dt);
        const offsetX=px-filteredX,stepX=(velocityX+spring*offsetX)*dt;
        const offsetY=py-filteredY,stepY=(velocityY+spring*offsetY)*dt;
        px=filteredX+(offsetX+stepX)*decay;py=filteredY+(offsetY+stepY)*decay;
        velocityX=(velocityX-spring*stepX)*decay;velocityY=(velocityY-spring*stepY)*decay;
        draw();
      }
      frame=requestAnimationFrame(tick);
    }
    const start=()=>{if(ctx&&!frame&&!paused&&visible&&!document.hidden&&root.isConnected){lastTime=null;frame=requestAnimationFrame(tick);}};
    const artworks=[...root.querySelectorAll('.fx-abstract')], artworkVisibility=new WeakMap();
    const updateArtwork=artwork=>{const running=!paused&&!document.hidden&&artworkVisibility.get(artwork)&&!artwork.closest('[hidden]');artwork.querySelectorAll('span').forEach(shape=>{shape.style.animationPlayState=running?'running':'paused';});};
    const syncMotion=()=>{
      root.classList.toggle('fx-paused',paused);
      cancelAnimationFrame(frame);frame=0;if(paused){targetX=targetY=px=py=filteredX=filteredY=velocityX=velocityY=0;resetPointers();}draw();start();artworks.forEach(updateArtwork);progress();updateNav();
    };
    on(reduced,'change',()=>{paused=reduced.matches;syncMotion();});
    on(document,'visibilitychange',()=>{cancelAnimationFrame(frame);frame=0;artworks.forEach(updateArtwork);start();});
    on(root.querySelector('.fx-hero'),'pointermove',e=>{if(paused||!finePointer.matches||e.pointerType==='touch'||!canvas||!w||!h)return;const r=canvas.getBoundingClientRect();targetX=Math.max(-.5,Math.min(.5,(e.clientX-r.left)/w-.5));targetY=Math.max(-.5,Math.min(.5,(e.clientY-r.top)/h-.5));},{passive:true});
    on(root.querySelector('.fx-hero'),'pointerleave',()=>{targetX=targetY=0;});
    const heroObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(!visible){cancelAnimationFrame(frame);frame=0;}else start();}):null;if(canvas)heroObserver?.observe(canvas);
    const artworkObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{artworkVisibility.set(entry.target,entry.isIntersecting);updateArtwork(entry.target);})):null;
    artworks.forEach(artwork=>{if(artworkObserver)artworkObserver.observe(artwork);else artworkVisibility.set(artwork,true);});
    const sizeObserver='ResizeObserver' in window?new ResizeObserver(resize):null;if(canvas)sizeObserver?.observe(canvas);if(!sizeObserver)on(window,'resize',resize);

    // Native dialogs preserve keyboard focus, Escape dismissal and inert background.
    const openers = new WeakMap(), returnFocus = new WeakMap(), closingDialogs = new Map(), detailAnimations = new Map();
    const dialogs=[...root.querySelectorAll('dialog')];
    const closeDialog = (dialog, immediate=false, restoreFocus=true) => {
      if(!dialog.open||closingDialogs.has(dialog))return;
      returnFocus.set(dialog,restoreFocus);
      if(immediate||paused||reduced.matches||typeof dialog.animate!=='function'){dialog.close();return;}
      dialog.dataset.closing='true';
      const animation=dialog.animate([{opacity:getComputedStyle(dialog).opacity,transform:getComputedStyle(dialog).transform},{opacity:0,transform:'translateY(8px) scale(.99)'}],{duration:180,easing:'cubic-bezier(.4,0,1,1)'});
      closingDialogs.set(dialog,animation);
      animation.onfinish=()=>{closingDialogs.delete(dialog);delete dialog.dataset.closing;if(dialog.open)dialog.close();};
    };
    root.querySelectorAll('[data-open]').forEach(button=>{
      const dialog=dialogs.find(item=>item.id===button.dataset.open);if(!dialog)return;
      button.setAttribute('aria-haspopup','dialog');button.setAttribute('aria-controls',dialog.id);
      on(button,'click',()=>{
        if(dialog.open)return;
        openers.set(dialog,button);returnFocus.set(dialog,true);dialog.showModal();lockScroll(dialog);
        const initial=dialog.querySelector('[autofocus], input[type="search"]')||dialog.querySelector('h2')||dialog.querySelector('[data-close]');
        if(initial){if(initial.tagName==='H2')initial.tabIndex=-1;initial.focus({preventScroll:true});}
      });
    });
    dialogs.forEach(dialog=>{
      const title=dialog.querySelector('h2');if(title&&!dialog.hasAttribute('aria-labelledby')){title.id||=dialog.id+'Title';dialog.setAttribute('aria-labelledby',title.id);}
      if(!title&&!dialog.hasAttribute('aria-label'))dialog.setAttribute('aria-label',dialog.classList.contains('fx-menu')?'Main menu':'Store information');
      on(dialog,'close',()=>{closingDialogs.get(dialog)?.cancel();closingDialogs.delete(dialog);delete dialog.dataset.closing;unlockScroll(dialog);const opener=openers.get(dialog);if(returnFocus.get(dialog)!==false&&opener?.isConnected&&!signal.aborted)opener.focus({preventScroll:true});});
      on(dialog,'cancel',event=>{event.preventDefault();closeDialog(dialog);});
      on(dialog,'keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeDialog(dialog);}});
      let backdropDown=false;
      const outside=event=>{const r=dialog.getBoundingClientRect();return event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom);};
      on(dialog,'pointerdown',event=>{backdropDown=outside(event);});
      on(dialog,'click',event=>{if(backdropDown&&outside(event))closeDialog(dialog);backdropDown=false;});
      dialog.querySelectorAll('[data-close],[data-dismiss]').forEach(button=>on(button,'click',()=>{const dismiss=button.hasAttribute('data-dismiss');closeDialog(dialog,dismiss,!dismiss);}));
    });
    // One open row in each accordion group; semantic details remain usable without JS.
    const settleDetail=(detail,expanded)=>{
      const height=detail.getBoundingClientRect().height;
      detailAnimations.get(detail)?.animation.cancel();detailAnimations.delete(detail);
      if(paused||reduced.matches||typeof detail.animate!=='function'){detail.open=expanded;detail.style.overflow='';return;}
      if(expanded)detail.open=true;
      const target=expanded?detail.getBoundingClientRect().height:detail.querySelector('summary').getBoundingClientRect().height;
      if(Math.abs(height-target)<1){detail.open=expanded;detail.style.overflow='';return;}
      detail.style.overflow='hidden';
      const animation=detail.animate([{height:height+'px'},{height:target+'px'}],{duration:Math.min(380,240+Math.abs(target-height)*.35),easing:'cubic-bezier(.22,1,.36,1)'});
      detailAnimations.set(detail,{animation,expanded});
      animation.onfinish=()=>{if(detailAnimations.get(detail)?.animation!==animation)return;detailAnimations.delete(detail);detail.open=expanded;detail.style.overflow='';};
    };
    root.querySelectorAll('.fx-accordion,.fx-faq-list').forEach(group=>{
      const rows=[...group.querySelectorAll('details')];
      rows.forEach(detail=>{
        on(detail.querySelector('summary'),'click',event=>{event.preventDefault();const expanded=!(detailAnimations.get(detail)?.expanded??detail.open);if(expanded)rows.forEach(other=>{if(other!==detail&&(other.open||detailAnimations.has(other)))settleDetail(other,false);});settleDetail(detail,expanded);});
        on(detail,'toggle',()=>{if(detail.open&&!detailAnimations.has(detail))rows.forEach(other=>{if(other!==detail&&other.open)settleDetail(other,false);});});
      });
    });
    root.querySelectorAll('[role="tablist"]').forEach(tablist=>{
      const tabs=[...tablist.querySelectorAll('[role="tab"]')];
      const panels=tabs.map(tab=>[...root.querySelectorAll('[role="tabpanel"]')].find(panel=>panel.id===tab.getAttribute('aria-controls')));
      const choose=index=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;if(panels[i]){panels[i].hidden=i!==index;panels[i].tabIndex=0;}});artworks.forEach(updateArtwork);};
      const vertical=tablist.getAttribute('aria-orientation')==='vertical',rtl=getComputedStyle(tablist).direction==='rtl';
      tabs.forEach((tab,index)=>{on(tab,'click',()=>choose(index));on(tab,'keydown',event=>{
        let next;if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;
        else if(event.key===(vertical?'ArrowDown':rtl?'ArrowLeft':'ArrowRight'))next=(index+1)%tabs.length;
        else if(event.key===(vertical?'ArrowUp':rtl?'ArrowRight':'ArrowLeft'))next=(index+tabs.length-1)%tabs.length;else return;
        event.preventDefault();choose(next);tabs[next].focus({preventScroll:true});
      });});
      choose(Math.max(0,tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true')));
    });
    const rail=root.querySelector('.fx-rail'), arrows=[...root.querySelectorAll('[data-slide]')];
    const move = direction=>{cancelSettle();rail?.classList.remove('dragging');rail?.scrollBy({left:direction*((rail.firstElementChild?.getBoundingClientRect().width||300)+(parseFloat(getComputedStyle(rail).gap)||18)),behavior:paused?'instant':'smooth'});};
    arrows.forEach(button=>on(button,'click',()=>{cancelSettle();rail?.classList.remove('dragging');move(Number(button.dataset.slide));}));
    on(rail,'keydown',event=>{
      if(event.target!==rail)return;
      cancelSettle();rail.classList.remove('dragging');
      if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
      if(['Home','End'].includes(event.key)){event.preventDefault();rail.scrollTo({left:event.key==='Home'?0:rail.scrollWidth,behavior:paused?'instant':'smooth'});}
    });
    let drag=null, suppressClick=false, settleFrame=0;
    const cancelSettle=()=>{cancelAnimationFrame(settleFrame);settleFrame=0;};
    const settleRail=velocity=>{
      if(!rail)return;
      cancelSettle();
      const start=rail.scrollLeft,max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      const origin=rail.getBoundingClientRect().left;
      const targets=[...rail.children].map(card=>Math.max(0,Math.min(max,card.getBoundingClientRect().left-origin+start)));
      const projected=Math.max(0,Math.min(max,start+Math.max(-180,Math.min(180,velocity*150))));
      const target=targets.reduce((nearest,value)=>Math.abs(value-projected)<Math.abs(nearest-projected)?value:nearest,0);
      const finish=()=>{rail.scrollLeft=target;rail.classList.remove('dragging');settleFrame=0;};
      if(paused||Math.abs(target-start)<1){finish();return;}
      const began=performance.now(),offset=start-target,speed=Math.max(-1800,Math.min(1800,velocity*1000)),spring=12;
      const animate=time=>{
        const t=(time-began)/1000,decay=Math.exp(-spring*t);
        const position=target+(offset+(speed+spring*offset)*t)*decay;
        rail.scrollLeft=Math.max(0,Math.min(max,position));
        if(!paused&&t<1.1&&(t<.15||Math.abs(position-target)>.35))settleFrame=requestAnimationFrame(animate);else finish();
      };
      settleFrame=requestAnimationFrame(animate);
    };
    on(rail,'pointerdown',event=>{
      if(event.pointerType==='touch'){cancelSettle();rail.classList.remove('dragging');}
      if(event.pointerType!=='mouse'||event.button!==0)return;
      cancelSettle();rail.classList.add('dragging');
      drag={x:event.clientX,left:rail.scrollLeft,lastX:event.clientX,time:event.timeStamp,velocity:0,moved:false};
    });
    on(rail,'dragstart',event=>event.preventDefault());
    on(window,'pointermove',event=>{
      if(!drag)return;
      const delta=event.clientX-drag.x;
      if(Math.abs(delta)>6||drag.moved){
        drag.moved=true;
        const elapsed=event.timeStamp-drag.time;
        if(elapsed>0)drag.velocity=(drag.lastX-event.clientX)/elapsed;
        drag.lastX=event.clientX;drag.time=event.timeStamp;
        rail.scrollLeft=drag.left-delta;
      }
    });
    const stopDrag=event=>{
      if(!drag)return;
      suppressClick=drag.moved;
      const velocity=event?.type==='pointercancel'||event?.timeStamp-drag.time>100?0:drag.velocity;
      drag=null;settleRail(velocity);
      later(()=>{suppressClick=false;},0);
    };
    on(window,'pointerup',stopDrag);on(window,'pointercancel',stopDrag);
    on(window,'blur',stopDrag);
    on(rail,'wheel',()=>{cancelSettle();rail.classList.remove('dragging');},{passive:true});
    on(rail,'click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;}},{capture:true});
    const railStatus=root.querySelector('[data-rail-status]'), railProgress=root.querySelector('[data-rail-progress]');
    const cards=rail?[...rail.children]:[];
    const updateArrows=()=>{
      if(!rail)return;
      arrows.forEach(button=>{button.disabled=Number(button.dataset.slide)<0?rail.scrollLeft<2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;});
      const bounds=rail.getBoundingClientRect();
      const visibleCards=cards.map((card,index)=>({index,rect:card.getBoundingClientRect()})).filter(({rect})=>Math.min(rect.right,bounds.right)-Math.max(rect.left,bounds.left)>rect.width*.5);
      const first=(visibleCards[0]?.index??0)+1,last=(visibleCards.at(-1)?.index??0)+1;
      const pad=value=>String(value).padStart(2,'0');
      if(railStatus){railStatus.textContent=`${pad(first)}${first===last?'':` — ${pad(last)}`} / ${pad(cards.length)}`;railStatus.setAttribute('aria-label',`Stories ${first} to ${last} of ${cards.length}`);}
      railProgress?.style.setProperty('--fx-rail-progress',String(Math.min(1,(rail.scrollLeft+rail.clientWidth)/rail.scrollWidth)));
    };
    const railObserver='ResizeObserver' in window?new ResizeObserver(updateArrows):null;
    if(rail)railObserver?.observe(rail);
    on(rail,'scroll',updateArrows,{passive:true});on(window,'resize',updateArrows);updateArrows();
    const resetPointers=()=>cards.forEach(card=>{card.removeAttribute('data-pointer-active');card.style.removeProperty('--fx-pointer-x');card.style.removeProperty('--fx-pointer-y');});
    cards.forEach(card=>{
      on(card,'pointermove',event=>{
        if(paused||!finePointer.matches||event.pointerType==='touch')return;
        const rect=card.getBoundingClientRect();
        card.style.setProperty('--fx-pointer-x',`${(event.clientX-rect.left)/rect.width*100}%`);
        card.style.setProperty('--fx-pointer-y',`${(event.clientY-rect.top)/rect.height*100}%`);
        card.setAttribute('data-pointer-active','');
      },{passive:true});
      on(card,'pointerleave',()=>card.removeAttribute('data-pointer-active'));
    });
    // Read-on-scroll typography. All text remains in the DOM for assistive technology.
    const read=root.querySelector('[data-read]');
    if(read&&!read.dataset.wordsReady){const words=read.textContent.trim().split(/\s+/);read.textContent='';words.forEach((word,i)=>{const span=document.createElement('span');span.textContent=word+(i<words.length-1?' ':'');read.append(span);});read.dataset.wordsReady='true';}
    let scrollFrame=0;
    const progress=()=>{scrollFrame=0;if(!read)return;const r=read.getBoundingClientRect(),amount=paused?1:Math.max(0,Math.min(1,(innerHeight*.85-r.top)/(innerHeight*.48)));[...read.children].forEach((span,i)=>span.classList.toggle('lit',i/read.children.length<amount));};
    on(window,'scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(progress);},{passive:true});on(window,'resize',progress);progress();
    const nav=root.querySelector('.fx-nav');
    const navSvg=nav?document.createElementNS('http://www.w3.org/2000/svg','svg'):null;
    const navParts=nav?[nav.querySelector('.fx-logo'),...nav.querySelectorAll('.fx-nav__pill>a'),nav.querySelector('.fx-nav__actions')].filter(Boolean):[];
    if(navSvg){
      navSvg.classList.add('fx-nav-liquid');navSvg.setAttribute('aria-hidden','true');
      navSvg.innerHTML='<defs><linearGradient id="FxLiquidColour" x1="0" y1="0" x2="0" y2="1"><stop stop-color="#302a22"/><stop offset="1" stop-color="#211e19"/></linearGradient></defs><g class="fx-nav-droplets" fill="url(#FxLiquidColour)" stroke="#d8c3a338" stroke-width="1">'+navParts.map(()=>'<rect rx="29"/>').join('')+'</g><rect class="fx-nav-finished" rx="29" fill="url(#FxLiquidColour)" stroke="#d8c3a338" stroke-width="1"/>';
      nav.prepend(navSvg);nav.classList.add('has-liquid');
    }
    const navDroplets=navSvg?.querySelector('.fx-nav-droplets'),navRects=navSvg?[...navSvg.querySelectorAll('g rect')]:[],navBar=navSvg?.querySelector('.fx-nav-finished');
    let navGeometry=[];
    const measureNav=()=>{
      if(!navSvg)return;
      const bounds=nav.getBoundingClientRect();navSvg.setAttribute('viewBox',`0 0 ${bounds.width} ${bounds.height}`);
      navGeometry=navParts.map(part=>{const rect=part.getBoundingClientRect();return {x:rect.left-bounds.left,width:rect.width};});
      navRects.forEach(rect=>{rect.setAttribute('y','2');rect.setAttribute('height',String(Math.max(0,bounds.height-4)));});
      navBar.setAttribute('x','.5');navBar.setAttribute('y','2');navBar.setAttribute('width',String(Math.max(0,bounds.width-1)));navBar.setAttribute('height',String(Math.max(0,bounds.height-4)));
    };
    const paintNav=()=>{
      if(!navSvg)return;
      const blend=Math.max(0,Math.min(1,navValue)),mix=Math.max(0,Math.min(1,(blend-.55)/.45)),finish=mix*mix*(3-2*mix);
      nav?.style.setProperty('--fx-nav-merge',String(blend));navDroplets.setAttribute('opacity',String(1-finish));
      navRects.forEach((rect,i)=>{const part=navGeometry[i];if(!part)return;const before=i?(part.x-navGeometry[i-1].x-navGeometry[i-1].width)*blend*.65:0,after=i<navGeometry.length-1?(navGeometry[i+1].x-part.x-part.width)*blend*.65:0;rect.setAttribute('x',String(part.x-before));rect.setAttribute('width',String(part.width+before+after));});
      navBar.setAttribute('opacity',String(finish));
    };
    let navFrame=0,navValue=Math.max(0,Math.min(1,scrollY/320)),navTarget=navValue,navVelocity=0,navTime=0;
    const animateNav=time=>{
      navFrame=0;
      const dt=Math.min(.05,(time-(navTime||time-16.67))/1000);navTime=time;
      const offset=navValue-navTarget,spring=10,decay=Math.exp(-spring*dt),step=(navVelocity+spring*offset)*dt;
      navValue=navTarget+(offset+step)*decay;navVelocity=(navVelocity-spring*step)*decay;
      if(Math.abs(navTarget-navValue)<.0005&&Math.abs(navVelocity)<.0005){navValue=navTarget;navVelocity=0;}
      paintNav();
      if(navVelocity||navValue!==navTarget)navFrame=requestAnimationFrame(animateNav);else navTime=0;
    };
    const updateNav=()=>{
      nav?.classList.toggle('is-scrolled',scrollY>30);
      navTarget=Math.max(0,Math.min(1,scrollY/320));
      if(paused||reduced.matches){cancelAnimationFrame(navFrame);navFrame=0;navTime=navVelocity=0;navValue=navTarget;paintNav();}
      else if(!navFrame)navFrame=requestAnimationFrame(animateNav);
      const section=root.querySelector('#Questions'),world=root.querySelector('#Discover');
      const careActive=section&&section.getBoundingClientRect().top<innerHeight*.4;
      const worldActive=world&&world.getBoundingClientRect().top<innerHeight*.4&&!careActive;
      nav?.querySelector('[data-nav="care"]')?.classList.toggle('is-active',Boolean(careActive));
      nav?.querySelector('[data-nav="world"]')?.classList.toggle('is-active',Boolean(worldActive));
    };
    measureNav();on(window,'scroll',updateNav,{passive:true});updateNav();
    const navObserver='ResizeObserver' in window?new ResizeObserver(()=>{measureNav();paintNav();}):null;if(nav)navObserver?.observe(nav);
    on(window,'resize',()=>{measureNav();updateNav();paintNav();});paintNav();
    // A supported privacy banner remains owned by Shopify.
    // Subtle button motion is limited to transform/opacity, not document scrolling.
    root.querySelectorAll('.fx-accordion details,.fx-faq-list details').forEach(detail=>{
      if(detail.children[1])detail.children[1].classList.add('fx-detail-body');
    });
    // Section lifecycle cleanup for the Shopify editor.
    let activeTransition=null;
    on(window,'pageswap',event=>{const next=event.activation?.entry?.url;if(event.viewTransition&&(reduced.matches||!next||!new URL(next).pathname.startsWith('/products/')))event.viewTransition.skipTransition();});
    on(window,'pagereveal',event=>{activeTransition=event.viewTransition;if(reduced.matches)activeTransition?.skipTransition();});
    ['pointerdown','keydown','wheel'].forEach(type=>on(document,type,()=>activeTransition?.skipTransition(),{passive:true,capture:true}));
    const cleanup=()=>{
      controller.abort();cancelAnimationFrame(frame);cancelAnimationFrame(scrollFrame);cancelAnimationFrame(navFrame);cancelSettle();rail?.classList.remove('dragging');timers.forEach(clearTimeout);
      orb?.dispose();
      collectionScenes.forEach(scene=>scene.dispose());
      navSvg?.remove();nav?.classList.remove('has-liquid');
      heroObserver?.disconnect();sizeObserver?.disconnect();artworkObserver?.disconnect();railObserver?.disconnect();navObserver?.disconnect();
      closingDialogs.forEach(animation=>animation.cancel());
      detailAnimations.forEach(({animation},detail)=>{animation.cancel();detail.style.overflow='';});
      dialogs.forEach(dialog=>{if(dialog.open)dialog.close();unlockScroll(dialog);});
      resetPointers();root.removeAttribute('data-ready');instances.delete(root);
    };
    root.fxCleanup=cleanup;
    instances.set(root,cleanup);
    resize();syncMotion();
  });
  let refreshTimer;
  const refresh=()=>{clearTimeout(refreshTimer);instances.forEach(cleanup=>cleanup());initialize();};
  window.AstrellaExperience={refresh};
  initialize();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',()=>{
    instances.forEach(cleanup=>cleanup());clearTimeout(refreshTimer);refreshTimer=setTimeout(initialize,0);
  });
})();

